import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import MobileUnderCalAds from "../../Ads"
const TITLE = "تحويل الوزن - محول وحدات الوزن";
const DESCRIPTION =
  "حوّل وحدات الوزن المختلفة بدقة وسهولة باستخدام أداة تحويل الوزن. احصل على قياسات دقيقة بين الكيلوغرامات والأرطال والمزيد.";
const KEYWORDS =
  "تحويل الوزن, محول الوزن, تحويل الكيلوغرامات, تحويل الأرطال, أدوات قياس الوزن, حاسبة تحويل الوزن";
const OG_URL = "https://do-calculate.com/ar/unit_converter/weight/";
const weightParameters = {
  kg: "كيلوغرام",
  g: "غرام",
  mg: "ميليغرام",
  metricton: "طن متري",
  longton: "طن طويل",
  shortton: "طن قصير",
  pound: "رطل",
  ounce: "أوقية",
  carat: "قيراط",
  amu: "وحدة كتلة ذرية",
};
const weights = Object.keys(weightParameters);
function UnitsList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (parameters, parameterNames) => (
    <table >
      <thead>
        <tr>
          <th >من الوحدة</th>
          <th >إلى الوحدة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {parameters
          .filter((fromParams) =>
            parameterNames[fromParams].includes(searchTerm)
          )
          .map((fromParams) =>
            parameters.map((toParams) => {
              if (fromParams !== toParams) {
                const url = `/calculator/ar/unit_converter/weight/${fromParams}/${toParams}/`;
                return (
                  <tr key={`${fromParams}-${toParams}`}>
                    <td>{parameterNames[fromParams]}</td>
                    <td>{parameterNames[toParams]}</td>
                    <td>
                      <a href={url}>
                        تحويل من {parameterNames[fromParams]} إلى{" "}
                        {parameterNames[toParams]}
                      </a>
                    </td>
                  </tr>
                );
              }
              return null;
            })
          )}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
         <MobileUnderCalAds />
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>الوزن</h2>
          <input
            type="text"
            placeholder="ابحث عن وحدة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(weights, weightParameters)}
        <br />
      </div>
    </div>
  );
}
export default UnitsList;
